const TOKEN_KEY = '@casaflora-token'

export const getToken = () => localStorage.getItem(TOKEN_KEY)
export const setToken = token => {
  localStorage.setItem(TOKEN_KEY, token)
}
export const removeToken = () => {
  //console.log('Removendo token atual');
  localStorage.removeItem(TOKEN_KEY)
  localStorage.clear();
}
